import { useState, useEffect } from 'react';
import { semanticBreakpoints } from '../theme/tokens/semantic';

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Defensive check for window.matchMedia
    if (!window.matchMedia) {
      console.warn('window.matchMedia is not available');
      return;
    }

    const media = window.matchMedia(query);

    // Defensive check for the returned media query
    if (!media) {
      console.warn('window.matchMedia returned undefined for query:', query);
      return;
    }

    // Set initial value
    setMatches(media.matches || false);

    // Create listener function
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Add listener
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else if (media.addListener) {
      // Fallback for older browsers
      media.addListener(listener);
    }

    // Cleanup
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else if (media.removeListener) {
        // Fallback for older browsers
        media.removeListener(listener);
      }
    };
  }, [query]);

  return matches;
};

export const useIsDesktop = () => useMediaQuery(`(min-width: ${semanticBreakpoints.desktop})`);